import { ExternalToolSteps } from "../../../data/enums"
import { ExternState } from "./model"

export const DEFAULT_STATE: ExternState = {
    page: ExternalToolSteps.ContractOpening,
}

export * from "./model"
